/**
 * The Settings dialog's shared look (owner, 2026-10-11: "simple and powerful,
 * not colourful"). One neutral palette — ink on white, light ink on charcoal —
 * and no accent colour anywhere in the panel, so every tab reads as one object.
 */

export const S_INPUT =
  'h-10 w-full rounded-lg border border-ink-200 bg-white px-3 text-sm text-ink-900 ' +
  'placeholder:text-ink-400 transition focus:border-ink-500 focus:outline-none focus:ring-4 focus:ring-ink-900/5 ' +
  'dark:border-white/10 dark:bg-ink-950 dark:text-ink-dim dark:placeholder:text-ink-500 ' +
  'dark:focus:border-white/30 dark:focus:ring-white/5';

export const S_BTN_PRIMARY =
  'inline-flex h-9 items-center justify-center gap-2 rounded-lg bg-ink-900 px-4 text-sm font-medium text-white ' +
  'transition hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-400 focus-visible:ring-offset-2 ' +
  'disabled:cursor-not-allowed disabled:opacity-40 dark:bg-ink-dim dark:text-ink-950 dark:hover:bg-white ' +
  'dark:focus-visible:ring-offset-ink-900';

export const S_BTN =
  'inline-flex h-9 items-center justify-center gap-2 rounded-lg border border-ink-200 bg-white px-3.5 text-sm font-medium ' +
  'text-ink-800 transition hover:bg-ink-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-400 ' +
  'disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:bg-transparent dark:text-ink-dim dark:hover:bg-white/5';

export const S_BTN_GHOST =
  'inline-flex h-9 items-center justify-center gap-2 rounded-lg px-3 text-sm font-medium text-ink-600 transition ' +
  'hover:bg-ink-100 hover:text-ink-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-400 ' +
  'disabled:cursor-not-allowed disabled:opacity-40 dark:text-ink-300 dark:hover:bg-white/5 dark:hover:text-ink-dim';

/** A bordered surface inside a tab (lists, stat tiles). */
export const S_CARD = 'rounded-xl border border-ink-200 dark:border-white/10';

/** Small section heading inside a tab. */
export const S_HEADING = 'text-[13px] font-semibold text-ink-900 dark:text-ink-dim';

export const S_MUTED = 'text-ink-500 dark:text-ink-400';
